import { useEffect, useState } from "react";
import { CustomGridTable } from "../../blueplanitUtils/CustomGridTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchAccessKeys, GenrateAccessKeys, revokeAccessKeyThunk, deleteAccessKeyThunk } from "../../Slices/Thunk/desktopAccesskeyThunk";
import { message, Modal, Menu, Dropdown } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { setLoader } from "../../Slices/loaderSlice";
import { AntdButton, InputField, SelectInput } from "../../blueplanitUtils/InputField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { setAccessKeys } from "../../Slices/Thunk/desktopAccesskeyThunk";


export const AccessKeys = () => {
    const dispatch = useDispatch();

    const [tableRows, setTableRows] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const allemployees = useSelector((state) => state.employee.AllEmployees);
    useEffect(() => {
        dispatch(fetchAccessKeys({ page: { current: currentPage } }));
    }, [dispatch, currentPage]);

    const accessKeys = useSelector(
        (state) => state.accessKeys?.data || []
    );

    const employeeOptions = allemployees?.map((item) => ({
        label: `${item.firstname} ${item.lastname}`,
        value: item.id,
    })) || [];
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        employeeId: null,
        systemName: "",
        systemType: "",
    });

    useEffect(() => {
        dispatch(setLoader(!accessKeys?.records?.length));
    }, [accessKeys, dispatch]);


    const handleRevoke = (record) => {
        if (!record.status) {
            message.warning(`License for ${record.employeename} is already deactivated`);
            return;
        }

        Modal.confirm({
            title: "Are you sure?",
            content: `Do you want to deactivate the license for ${record.employeename}?`,
            okText: "Yes",
            cancelText: "No",
            onOk: async () => {
                try {
                    await dispatch(revokeAccessKeyThunk({ key: record.key })).unwrap();

                    setTableRows((prev) =>
                        prev.map((row) =>
                            row.key === record.key
                                ? {
                                    ...row,
                                    status: false,
                                    platform: "",
                                    release: "",
                                    publicIp: "",
                                    arch: "",
                                    fingerprint: "",
                                    activatedAt: "",
                                }
                                : row
                        )
                    );
                    message.success("License deactivated successfully");
                } catch (err) {
                    message.error("Failed to revoke access key");
                }
            },
        });
    };


    const handleDelete = (record) => {
        Modal.confirm({
            title: "Are you sure?",
            content: `Do you want to delete the access key for ${record.employeename}?`,
            okText: "Yes",
            cancelText: "No",
            onOk: async () => {
                try {
                    await dispatch(deleteAccessKeyThunk({ key: record.key })).unwrap();

                    setTableRows((prev) =>
                        prev.filter((row) => row.key !== record.key)
                    );

                    message.success("Access key deleted successfully");
                } catch (err) {
                    message.error("Failed to delete access key");
                }
            },
        });
    };


    const columns = [
        { dataIndex: "employeename", title: "Employee Name", align: "center" },
        { dataIndex: "platform", title: "platform", align: "center" },
        { dataIndex: "release", title: "release", align: "center" },
        { dataIndex: "publicIp", title: "Public IP", align: "center" },
        { dataIndex: "arch", title: "Architecture", align: "center" },
        {
            dataIndex: "status", title: "Status", align: "center",
            render: (value) => {
                const isActivated = value === true || value === "true";
                return (
                    <span style={{ color: isActivated ? "green" : "red", fontWeight: "bold" }}>
                        {isActivated ? "Activated" : "Not Activated"}
                    </span>
                );
            },

        },
        {
            dataIndex: "key",
            title: "Access Key",
            align: "center",
            render: (value) => (
                <span
                    style={{ cursor: "pointer", color: "#1976d2", fontWeight: "bold" }}
                    onClick={() => {
                        navigator.clipboard.writeText(value);
                        message.success(`Key was copied to clipboard: ${value}`);
                    }}
                >
                    {value}
                </span>
            ),
        },
        // { dataIndex: "fingerprint", title: "Fingerprint", width: 300, align: "center" },
        {
            dataIndex: "activatedAt",
            title: "Activated At",
            align: "center",

        },
        {
            dataIndex: "sysName",
            title: "System Name",
            align: "center",

        },
        {
            dataIndex: "sysOS",
            title: "System OS",
            align: "center",

        },
        {
            title: "Actions",
            dataIndex: "actions",
            align: "center",
            render: (_, record) => {
                const items = [
                    record?.status && {
                        key: "revoke",
                        label: "Revoke",
                        onClick: () => handleRevoke(record),
                    },
                    {
                        key: "delete",
                        label: "Delete",
                        onClick: () => handleDelete(record),
                    },
                ];

                return (
                    <Dropdown
                        menu={{ items }}
                        placement="bottom"
                        trigger={["click"]}
                    >
                        <span
                            style={{
                                cursor: "pointer",
                                fontSize: "18px",
                                lineHeight: 1,
                            }}
                        >
                            <MoreOutlined />
                        </span>
                    </Dropdown>
                );
            },
        }

    ];

    useEffect(() => {
        const mappedRows = accessKeys?.records?.map((item, index) => ({
            id: item.key || index,
            key: item.key,
            status: item.status,
            fingerprint: item.fingerprint,
            platform: item.platform,
            release: item.release,
            sysName: item.sysName,
            sysOS: item.sysOS,
            publicIp: item.publicIp,
            arch: item.arch,
            activatedAt: item.activatedAt
                ? new Date(Number(item.activatedAt)).toLocaleString()
                : "",
            employeename: item.employeename,
        }));

        setTableRows(mappedRows);
    }, [accessKeys]);

    const handleOpenAddModal = () => {
        setIsAddModalOpen(true);
    };

    const handleCloseAddModal = () => {
        setIsAddModalOpen(false);
        setFormData({
            employee: null,
            systemName: "",
            systemType: "",
        });
    };

    const handleGenerate = async () => {
        try {
            await dispatch(GenrateAccessKeys({
                employeeId: formData.employeeId,
                sysName: formData.systemName,
                sysOS: formData.systemType
            })).unwrap();

            message.success("Access key generated");

            setCurrentPage(1);
            dispatch(fetchAccessKeys({ page: { current: 1 } }));

            handleCloseAddModal();
        } catch (err) {
            message.error("Failed to generate access key");
        }
    };


    return (

        <div style={{ marginTop: 30 }}>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                <AntdButton
                    type="primary"
                    onClick={handleOpenAddModal}
                    label={
                        <>
                            <FontAwesomeIcon icon={faPlus} style={{ marginRight: 6, marginTop: "4px" }} />
                            Add
                        </>
                    }
                />
            </div>

            <CustomGridTable
                columns={columns}
                dataSource={tableRows}
                rowKey="key"
                Id="AccessKeysGrid"
                scroll={{ x: "max-content" }}
                bordered
                size="small"
                pagination={{
                    pageSize: 50,
                    current: currentPage,
                    onChange: page => setCurrentPage(page),
                    total: accessKeys?.totalCount || 0,
                    showSizeChanger: false
                }}
            />
            <Modal
                title="Generate Access Key"
                open={isAddModalOpen}
                onCancel={handleCloseAddModal}
                footer={[
                    <AntdButton key="cancel" label="Cancel" onClick={handleCloseAddModal} />,
                    <AntdButton key="generate" label=" Generate" type="primary" onClick={handleGenerate} />
                ]}
            >
                {/* Employee Name */}
                <div style={{ marginBottom: 12 }}>
                    <label>Employee Name</label>
                    <SelectInput
                        style={{ width: "100%" }}
                        placeholder="Select employee"
                        options={employeeOptions}
                        value={formData.employeeId}
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                        }
                        onChange={(value) =>
                            setFormData((prev) => ({ ...prev, employeeId: value }))
                        }
                    />
                </div>

                {/* System Name */}
                <div style={{ marginBottom: 12 }}>
                    <label>System Name</label>
                    <InputField
                        placeholder="Enter system name"
                        value={formData.systemName}
                        onChange={(e) =>
                            setFormData((prev) => ({ ...prev, systemName: e.target.value }))
                        }
                    />
                </div>

                {/* System Type */}
                <div>
                    <label>System Type</label>
                    <InputField
                        placeholder="Enter system type"
                        value={formData.systemType}
                        onChange={(e) =>
                            setFormData((prev) => ({ ...prev, systemType: e.target.value }))
                        }
                    />
                </div>
            </Modal>
        </div>

    );
};

